import { Skeleton } from "@mui/material"
import dayjs from "dayjs"
import { gstStateCodes } from "../../constants/data"
import { getStateName } from "../../utils/bookingHistoryHelper"
import {
  ContainerCardPayments,
  StyledHeading,
  ParaTag,
  GSTDetailsContainer,
  HoldingContainer,
  BoldSpan,
  DetailsDiv,
  FlexDiv,
  ContainerCardPay,
} from "./styles"
import { useAppSelector } from "../../app/hooks"
import { selectBookingHistory } from "../../slices/bookingHistorySlice"

const GstDetails = () => {
  const { bookingDetailsById, isDetailsByIdLoading } =
    useAppSelector(selectBookingHistory)

  const zohoContact = bookingDetailsById?.user_details?.gst_contacts?.find(
    (contact) =>
      contact.contact_info.gst_no === bookingDetailsById?.gst_details?.gstin,
  )
  return (
    <ContainerCardPayments>
      <StyledHeading>GST Details</StyledHeading>
      {isDetailsByIdLoading ? (
        <>
          {Array(4)
            .fill(null)
            .map((_, index) => (
              <ParaTag key={index}>
                <Skeleton animation="wave" />
              </ParaTag>
            ))}
        </>
      ) : (
        <GSTDetailsContainer>
          <HoldingContainer>
            <ParaTag>
              <BoldSpan>GSTIN:</BoldSpan>{" "}
              {bookingDetailsById?.gst_details?.gstin}
            </ParaTag>
            <ParaTag>
              <BoldSpan>State:</BoldSpan>{" "}
              {getStateName(
                bookingDetailsById?.gst_details?.gstin.substring(
                  0,
                  2,
                ) as keyof typeof gstStateCodes,
              )}
            </ParaTag>
          </HoldingContainer>
          <DetailsDiv>
            <ParaTag>
              <BoldSpan>Company Name:</BoldSpan>{" "}
              {bookingDetailsById?.gst_details?.company_name}
            </ParaTag>
            <ParaTag>
              <BoldSpan>Pincode:</BoldSpan>{" "}
              {bookingDetailsById?.gst_details?.pincode}
            </ParaTag>
          </DetailsDiv>
          <ParaTag>
            <BoldSpan>Company Address:</BoldSpan>{" "}
            {bookingDetailsById?.gst_details?.company_address}
          </ParaTag>
        </GSTDetailsContainer>
      )}

      {isDetailsByIdLoading ? (
        <>
          <Skeleton variant="rectangular" height={260} />
        </>
      ) : (
        Array.isArray(bookingDetailsById?.user_details?.gst_contacts) &&
        !!bookingDetailsById?.user_details?.gst_contacts?.length && (
          <>
            <StyledHeading>Zoho Contact</StyledHeading>
            <FlexDiv>
              {zohoContact && (
                <ContainerCardPay>
                  <ParaTag>
                    <BoldSpan>Contact ID:</BoldSpan> {zohoContact?.contact_id}
                  </ParaTag>
                  <ParaTag>
                    <BoldSpan>Contact Name:</BoldSpan>{" "}
                    {zohoContact?.contact_info?.contact_name}
                  </ParaTag>
                  <ParaTag>
                    <BoldSpan>Place Of Contact:</BoldSpan>{" "}
                    {zohoContact?.contact_info?.place_of_contact}
                  </ParaTag>
                  <ParaTag>
                    <BoldSpan>Status:</BoldSpan>{" "}
                    {zohoContact?.is_active ? "Active" : "Inactive"}
                  </ParaTag>
                  <ParaTag>
                    <BoldSpan>Created At:</BoldSpan>{" "}
                    {dayjs(zohoContact?.created_at)
                      .utcOffset("+05:30")
                      .format("hh:mm A, dddd, D MMMM YYYY")}
                  </ParaTag>
                </ContainerCardPay>
              )}
            </FlexDiv>
          </>
        )
      )}
    </ContainerCardPayments>
  )
}

export default GstDetails
